<template>
  <div class="header">
    <div class="logo clearfix">
      <img src="./logo.png" alt=""/>
      <h2>排水户管理系统</h2>
    </div>
    <div class="avatar-wrapper" @click="controlPerson = !controlPerson">
      <img class="avatar" :src="imgUrl" alt=" "/>
      <b class="el-icon-arrow-down"></b>
      <ul class="pesonSet" v-show="controlPerson">
        <li id="exit" @click="exitFun">
          <b class="icon-ico-quit"></b> <span>退出</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeHeader',
  data(){
    return {
      controlPerson:false
    }
  },
  computed: {
    imgUrl: function () {
      var userInfo = sessionStorage.getItem('drainage-userInfo');
      if (userInfo) {
        return JSON.parse(userInfo).HeadImgUrl;
      }else {
        return require('./Avatar.png');
      }
    }   
  },
  mounted(){
  },
  methods:{
    exitFun:function() {
      // 重置sessionStorage数据
      sessionStorage.clear();      
      this.$router.push({
        path: '/login'
      }); 
    }
  }
}
</script>
<style lang='stylus' scoped>
  @import '~@/assets/style/varible.styl';

  .header {
    height: 60px;
    width: 100%;
    background-color: #fff;
    padding: 0 20px 0 24px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
    position: relative;
    z-index: 9;

    .logo {
      float: left

      & > img {
        width: 32px;
        height: 32px;
        float: left;
        vertical-align: middle;
        margin-top: 14px;
      }

      & > h2 {
        font-size: 24px;
        float: left;
        font-weight: 600;
        vertical-align: middle;
        letter-spacing: 0;
        margin-left: 15px;
        height: 60px;
        line-height: 60px;
      }
    }

    .avatar-wrapper {
      position: relative;
      padding-top: 0;
      float: right
      cursor: pointer;

      & > img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-top: 15px;
        margin-right: 30px;
      }

      & > b {
        position: absolute;
        top: 25px;
        right: 0;
      }

      .pesonSet {
        position: absolute;
        width: 150px;
        right: -6px;
        top: 56px;
        background-color: #fff;
        z-index: 9999;
        border: 1px solid #CCCCCC;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
        /*display: none;*/

        & > li {
          height: 45px;
          box-sizing: border-box;
          padding-left: 15px;
          line-height: 45px;

          & > img {
            width: 22px;
            height: 22px;
            margin-top: 11px;
            float: left;
          }

          & > span {
            float: left;
            font-size: 13px;
            color: #757575;
            letter-spacing: 0;
            line-height: 45px;
            margin-left: 12px;

          }

          &:hover {
            background: #F0F6FF;
          }
        }

        &:before {
          content: ''; /*伪类下的属性*/
          display: block;
          position: absolute;
          top: -19px;
          right: 10px;
          width: 0;
          height: 0;
          overflow: hidden;
          font-size: 0; /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
          line-height: 0; /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
          border: 10px;
          border-style: dashed dashed solid dashed;
          border-color: transparent transparent #fff transparent;
          z-index: 200;

        }

        &:after {
          content: ''; /*伪类下的属性*/
          display: block;
          width: 0;
          height: 0;
          z-index: 199;
          overflow: hidden;
          font-size: 0; /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
          line-height: 0; /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
          border: 9px;
          border-style: dashed dashed solid dashed;
          border-color: transparent transparent #ccc transparent;
          position: absolute;
          top: -19px;
          right: 11px;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/home/components/header/header.vue